import { AuthenticateCognito } from './../actions/cognito'

export default (observer, store) => {
  // When Facebook is authenticated, sync with cognito
  observer.observe(
    (state) => state.facebook ? state.facebook.authState : null,
    (prev, next, state) => {
      if (next === 'connected') {
        store.dispatch(
          AuthenticateCognito('graph.facebook.com', state.facebook.authToken)
        )
      } else if (next === 'unknown') {
        window.history.pushState(null, 'Login', '/login')
      }
    })
}